import React from 'react';
import {Button} from "react-bootstrap";
import {FcNext, FcPrevious} from "react-icons/fc";
import {removeError, setError, showNavBar} from "../../_store/_actions/uiActions";
import {useDispatch, useSelector} from "react-redux";
import { useHistory } from "react-router-dom";
import {postData} from "../../_store/_actions/repositoryDataActions";
import 'react-toastify/dist/ReactToastify.css';
import {toast, ToastContainer} from "react-toastify";
import {getCurrentUser} from "../../_store/_actions/repositoryUserActions";

const NavBarButtons = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const {partnerId} = useSelector(state => state.repository.user)

    const notify = (message) => toast.error(message, {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const handleUserData = () => {
        switch (props.currentStep) {
            case 1:
                if (isPersonalDataValid()) {
                    savePersonalData();
                }
                break;
            case 2:
                if (isMembershipDataValid()) {
                    saveMembershipData();
                }
                break;
            case 3:
                if (isSaveOnDataValid()) {
                    saveSaveOnResortData();
                }
                break;
            default:
                break;
        }
    }

    const savePersonalData = () => {
        const personalData = {
            PartnerId: partnerId,
            FirstName: props.data.firstname,
            LastName: props.data.lastname,
            Email1: props.data.email,
            Address: props.data.address,
            PostalCode: props.data.zipcode,
            City: props.data.city,
            State: props.data.state,
            UserId: props.data.userId,
            StatusDescription: 'COMPLETED',
            Status: true
        }

        dispatch(postData('/partner', personalData, props)).then( response => {
            if (response.status === 200) {
                dispatch(getCurrentUser()).then((response) => {
                    dispatch(removeError());
                    props.nextStep();
                })
            }
        }).catch( error => {
            notify('Could not save member data!!');
        });
    }

    const saveMembershipData = () => {
        const contractData = {
            PartnerId: partnerId,
            Email: props.data.emailForm,
            ContractFolio: props.data.contractFolio.toString()
        }
        dispatch(postData('/Partner/CheckContractReef', contractData, props)).then( response => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    dispatch(removeError());
                    props.nextStep();
                } else {
                    {dispatch(setError('Contract match does not exist!')); return false}
                }
            }
        }).catch( error => {
            notify('Could not save contract data!!');
        });
    }

    const saveSaveOnResortData = () => {
        dispatch(postData('/saveonresort/createuser',props.saveon,props)).then( response => {
            if (response.status === 200) {

                const personalData = {
                    PartnerId: partnerId,
                    SaveOnEmail: props.saveon.Email,
                    SaveOnPassword: props.saveon.Password,
                    SaveOnFolio: response.data.account.userId
                }

                dispatch(postData('/partner', personalData, props)).then(response => {
                    if (response.status === 200) {
                        dispatch(removeError());
                        dispatch(showNavBar());
                        history.push("/mywallet");
                    }
                }).catch(error => {
                    notify('Could not save save on resort data!!');
                });
            }
        })
    }

    const previousStep = () => {
        props.previousStep();
        dispatch(removeError());
    }

    /*const saveMembershipData = () => {
        const personalData = {
            PartnerId: partnerId,
            ContractFolio: props.data.folioContrato.toString()
        }

        dispatch(postData('/partner', personalData, props)).then( response => {
            if (response.status === 200) {
                props.nextStep();
            }
        }).catch( error => {
            notify('Could not save contract data!!');
        });
    }*/

    const isPersonalDataValid = () => {
        if (props.data.firstname.trim().length === 0) { dispatch(setError('First name is required!')); return false};
        if (props.data.lastname.trim().length === 0) { dispatch(setError('Last name is required!')); return false};
        if (props.data.address.trim().length === 0) { dispatch(setError('Address is required!')); return false};
        if (props.data.city.trim().length === 0) { dispatch(setError('City name is required!')); return false};
        if (props.data.state.trim().length === 0) { dispatch(setError('State name is required!')); return false};
        if (props.data.zipcode.trim().length === 0) { dispatch(setError('Zip code name is required!')); return false};

        return true;
    }

    const isMembershipDataValid = () => {
        if (props.data.emailForm.trim().length === 0) {dispatch(setError('The email contract is required!')); return false};
        if (props.data.contractFolio.trim().length === 0) {dispatch(setError('The contract folio is required!')); return false};

        return true;
    }

    const isSaveOnDataValid = () => {
        if (props.data.emailUser.trim().length === 0) { dispatch(setError('Email is required!')); return false};
        if (props.data.password.trim().length === 0) { dispatch(setError('Password is required!')); return false};

        return true;
    }

    return (
        <>
            <ToastContainer />
            <div className="row">
                <div className="col-md-12">
                    <div className="float-right">
                        {
                            props.currentStep > 1 &&
                            <Button className="button button-3d button-blue"
                                    onClick={previousStep}
                            ><FcPrevious/><FcPrevious/> Previous Step
                            </Button>
                        }

                        <Button className="button button-3d button-blue"
                                onClick={ handleUserData }
                        > {props.currentStep < 3 ?'Next Step': 'Goto Wallet' } <FcNext/><FcNext/>
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NavBarButtons;
